(function () {
  const style = document.createElement('style');
  style.textContent = `
    .samples-btn {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
      color: rgba(0,0,0,0.25);
      padding: 5px;
      transition: color 0.2s, transform 0.15s;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .samples-btn:hover { transform: scale(1.25); color: rgb(var(--color-foreground)); }
    .samples-btn--active { color: rgb(var(--color-foreground)); }
    .samples-btn img { opacity: 0.3; transition: opacity 0.2s, filter 0.2s; width: 1em; height: 1em; display: block; filter: brightness(0); }
    .samples-btn:hover img { opacity: 0.7; }
    .samples-btn--active img { opacity: 1; filter: brightness(0); }
  `;
  document.head.appendChild(style);

  const STORAGE_KEY = 'samples';

  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6"/><path d="M10 3v6.8L5.2 17A2 2 0 0 0 6.9 20h10.2a2 2 0 0 0 1.7-3L14 9.8V3"/><path d="M6.5 16.5h11"/></svg>`;
  const svgFilled = svgIcon;
  const svgOutline = svgIcon;

  class SamplesManager {
    constructor() {
      try {
        this.list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(this.list)) this.list = [];
      } catch (e) {
        this.list = [];
      }
      this._init();
    }

    _init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-samples-btn]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          this.toggle(btn.dataset.handle);
        }
      }, true);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._updateAll());
      } else {
        this._updateAll();
      }
    }

    toggle(handle) {
      if (this.isInList(handle)) {
        this.list = this.list.filter(h => h !== handle);
      } else {
        this.list.push(handle);
      }
      this._save();
      this._updateAll();
    }

    isInList(handle) {
      return this.list.includes(handle);
    }

    _save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.list));
    }

    _updateAll() {
      document.querySelectorAll('[data-samples-btn]').forEach((btn) => {
        const active = this.isInList(btn.dataset.handle);
        btn.classList.toggle('samples-btn--active', active);
        btn.setAttribute('aria-label', active ? 'Verwijder van mijn samples' : 'Voeg toe aan mijn samples');
        const img = btn.querySelector('img');
        if (img) img.src = btn.dataset.iconDefault;
        const svg = btn.querySelector('svg');
        if (svg) svg.style.strokeWidth = active ? '2.2' : '1.5';
      });
    }
  }

  window.SamplesManager = new SamplesManager();
})();
